import SockJS from 'sockjs-client'
import { Client } from '@stomp/stompjs'
import processNotification from '@services/notification/notification-service'

var socket
var client

function connectWs(login, authToken, callback) {
  socket = new SockJS(`/ws?access_token=${authToken}`)
  client = new Client({
    brokerURL: '/ws',
    reconnectDelay: 0,
    heartbeatIncoming: 4000,
    heartbeatOutgoing: 4000,
    webSocketFactory: () => {
      return socket
    },
  })

  client.onConnect = function(frame) {
    client.subscribe(`/user/${login}/alerts`, tick => {
      if (tick && tick.body) {
        let body = JSON.parse(tick.body)
        processNotification(body)
      }
    })
  }

  client.onWebSocketClose = function(frame) {
    setTimeout(function() {
      connectWs(login, authToken, callback)
    }, 5000)
  }

  client.activate()
}

export default connectWs
